import { render } from "./IconGoal.vue?vue&type=template&id=74fae7d8&ts=true"
import script from "./IconGoal.vue?vue&type=script&lang=ts"
export * from "./IconGoal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__